import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import { translate } from 'react-switch-lang';
import './EventCardNew.css';
import { toast } from 'react-toastify';
import shareIcon from '../../assets/icons/share.svg';
import { buildDeepLink, shareDeepLink } from '../../utils/deepLink';
// import newlyWedIcon from '../../assets/Book Events/vectors-02.png';
// import birthUpTo7Icon from '../../assets/Book Events/vectors-03.png';
// import stressManagementIcon from '../../assets/Book Events/vectors-04.png';
// import healthCareIcon from '../../assets/Book Events/vectors-05.png';
// import lifeAfterDeathIcon from '../../assets/Book Events/vectors-06.png';
// import meditationYogaIcon from '../../assets/Book Events/vectors-07.png';
// import prenatalIcon from '../../assets/Book Events/vectors-08.png';
// import eightToFourteenIcon from '../../assets/Book Events/vectors-09.png';
// import scienceOfSpiritualityIcon from '../../assets/Book Events/vectors-10.png';
// import fifteenToTwentyEightIcon from '../../assets/Book Events/vectors-11.png';
// import languageIcon from '../../assets/Book Events/vectors-13.png';

const newlyWedIcon = 'https://res.cloudinary.com/dtuy184dc/image/upload/v1775279698/Suprajanan_Newly_Wed_Couples_e0p3gt.png';
const birthUpTo7Icon = 'https://res.cloudinary.com/dtuy184dc/image/upload/v1775279698/Nurturing_Kids_Birth_up_to_7_years_xe0ajs.png';
const stressManagementIcon = 'https://res.cloudinary.com/dtuy184dc/image/upload/v1775279698/Stress_Management_mh1fiq.png';
const healthCareIcon = 'https://res.cloudinary.com/dtuy184dc/image/upload/v1775279699/Health_Care_1_qunv8g.png';
const lifeAfterDeathIcon = 'https://res.cloudinary.com/dtuy184dc/image/upload/v1775279699/Life_after_Death_dnb210.png';
const meditationYogaIcon = 'https://res.cloudinary.com/dtuy184dc/image/upload/v1775279699/Meditation_Yoga_ijktju.png';   
const prenatalIcon = 'https://res.cloudinary.com/dtuy184dc/image/upload/v1775279701/Garbha_Sanskar_Prenatal_Education_1_vwf2af.png';
const eightToFourteenIcon = 'https://res.cloudinary.com/dtuy184dc/image/upload/v1775279701/Child_Development_8_to_14_years_jprffn.png';  
const scienceOfSpiritualityIcon = 'https://res.cloudinary.com/dtuy184dc/image/upload/v1775279698/Science_of_Spirituality_jzwya1.png';
const fifteenToTwentyEightIcon = 'https://res.cloudinary.com/dtuy184dc/image/upload/v1777011140/Youth_Power_15_to_28_years_1_kkb3ar.png';
const languageIcon = 'https://res.cloudinary.com/dtuy184dc/image/upload/v1773292592/vectors-13_agpnnl.png'; 

/**
 * New Event Card component
 * Reusable responsive card component matching the design image
 */
const EventCardNew = ({ event, onShare, history, currentFilters, t }) => {
    const [imageLoaded, setImageLoaded] = useState(false);
    
    const {
        event_id,
        category_label,
        topicId,
        topicName,
        subtopics,
        subtopicIds,
        subtopicDisplay,
        title,
        description,
        keywords = [],
        language,
        pricing = [],
        background_icon,
        title_url,
        eventType,
        eventTypeId,
        hasSchedule,
        hasActiveSchedule,
        futureScheduleCount,
        nextScheduleDate
    } = event;

    // Determine active status preferring server-provided `hasActiveSchedule`,
    // then legacy `hasSchedule`, then numeric counts.
    const isActive = (hasActiveSchedule !== undefined && hasActiveSchedule !== null)
        ? Boolean(hasActiveSchedule)
        : (hasSchedule !== undefined && hasSchedule !== null)
            ? Boolean(hasSchedule)
            : (futureScheduleCount !== undefined && futureScheduleCount !== null)
                ? Number(futureScheduleCount) > 0
                : undefined;

    // nextScheduleDate rendering removed per design request

    // Refs to measure category label width so we can position the status pill
    const categoryRef = useRef(null);
    const containerRef = useRef(null);

    useEffect(() => {
        const updateCategoryWidth = () => {
            try {
                if (categoryRef.current && containerRef.current) {
                    const w = categoryRef.current.offsetWidth;
                    containerRef.current.style.setProperty('--category-width', `${w}px`);
                }
            } catch (e) {
                // ignore measurement errors
            }
        };

        updateCategoryWidth();
        window.addEventListener('resize', updateCategoryWidth);
        return () => window.removeEventListener('resize', updateCategoryWidth);
    }, [category_label, title]);

    //old one not passing currently selected subtopic to eventdetails page
    // const getEventUrl = () => {
    //     // If currentFilters are provided, include them in the location state
    //     if (currentFilters) {
    //         return {
    //             pathname: `/event_details/${event_id}`,
    //             state: {
    //                 // ✅ PASS CORRECT TOPIC INFO
    //                 topicId: topicId,
    //                 topicTitle: topicName || category_label,
    //                 // Pass complete filter state for back navigation
    //                 topics: currentFilters?.topics || ['All'],
    //                 subTopics: currentFilters?.subTopics || ['All'],
    //                 subtopicIds: currentFilters?.subtopicIds || [],
    //                 language: currentFilters?.language || 'All',
    //                 events: currentFilters?.events || ['Residential Study Courses']
    //             }
    //         };
    //     }
    //     return `/event_details/${event_id}`;
    // };
    
    //changed this to pass currently selected subtopic to eventdetails page    // Use shared slugify helper


    const getEventUrl = () => {
        // Build minimal query-parameter-based URL using buildDeepLink (only event ID)
        const queryUrl = buildDeepLink({
            origin: '', // Empty origin for relative URL
            eventId: event_id
        });

        // Properly split the URL into pathname + search so React Router can match the route.
        // buildDeepLink may return something like '/event_details?event_id=7' — the '?' must
        // not be embedded in the pathname field, or the router treats it as a literal character
        // and fails to match the '/event_details/:eventId?' route (causing 404).
        const questionIdx = queryUrl.indexOf('?');
        const basePath = questionIdx !== -1 ? queryUrl.slice(0, questionIdx) : queryUrl;
        const existingSearch = questionIdx !== -1 ? queryUrl.slice(questionIdx + 1) : '';

        // Merge existing search params with topic_id
        const searchParams = new URLSearchParams(existingSearch);
        if (topicId) searchParams.set('topic_id', String(topicId));
        const searchString = searchParams.toString();

        // Always carry topic context in location.state for zero-latency access on the details page
        const topicState = topicId
            ? { topicId, topicTitle: topicName || category_label }
            : {};

        const locationObj = {
            pathname: basePath,
            ...(searchString ? { search: `?${searchString}` } : {}),
            state: topicState,
        };

        // If currentFilters are provided, merge them into state for back-navigation support
        if (currentFilters) {
            locationObj.state = {
                ...topicState,
                topics: currentFilters.topics || ['All'],
                subTopics: currentFilters.subTopics || ['All'],
                subtopicIds: currentFilters.subtopicIds || [],
                language: currentFilters.language || 'All',
                events: currentFilters.events || ['Residential Study Courses']
            };
        }

        return locationObj;
    };

    // Share / Deep-link handler
    const handleShare = async (e) => {
        // Prevent triggering parent navigation
        if (e && e.stopPropagation) e.stopPropagation();

        const origin = (typeof window !== 'undefined' && window.location && window.location.origin) ? window.location.origin : '';
        // Build deep link with event_id and origin (absolute URL)
        const deepLink = buildDeepLink({ origin, eventId: event_id });


        // Restore original share text format (as before)
        // Custom share message structure
        // Use eventType (e.g. "Residential Study Courses") instead of category_label (which is the topic)
        const category = eventType || 'Event';
        const eventName = title || '';
        let shortDesc = '';
        if (description) {
            // Remove HTML tags and trim
            shortDesc = String(description).replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
            if (shortDesc.length > 100) shortDesc = shortDesc.slice(0, 100) + '...';
        }
        // Include the URL only once in the text body (do NOT pass it as a separate `url` param)
        const shareText = `Check out the ${category}: "${eventName}" on Manashakti Research Centre:\n${shortDesc}\n${deepLink}`;

        // Always call onShare if provided, to open modal (match EventScheduleCard behavior)
        if (onShare) onShare(deepLink);
        try {
            await shareDeepLink({ title: eventName, text: shareText, url: deepLink });
        } catch (err) {
            // Fallback: copy to clipboard
            try {
                if (typeof navigator !== 'undefined' && navigator.clipboard && navigator.clipboard.writeText) {
                    await navigator.clipboard.writeText(deepLink);
                    alert('Link copied to clipboard!');
                }
            } catch (e) {
                alert('Unable to share or copy link.');
            }
        }
    };

    // Get topic URL for navigation
    const getTopicUrl = () => {
        if (topicId && topicName) {
            // URL encode the topic name for the route
            return `/topics/${encodeURIComponent(topicName)}/${topicId}`;
        }
        return null;
    };

    // Handle subtopic click - navigate to topics page for that subtopic
    // Route format (old flow): /topics/{topicName}/{topicId}/{subtopicId}
    const handleSubtopicClick = (subtopic, subtopicId) => {
        if (!subtopicId || !history) return;

        // Prefer topicName and topicId from event; fallback to category_label/title when needed
        const topicLabel = topicName || category_label || title || 'Topics';
        const topicIdToUse = topicId || (event && event.topicId) || null;

        // If we don't have a topicId, still navigate using topicLabel and subtopicId
        const pathname = topicIdToUse
            ? `/topics/${encodeURIComponent(topicLabel)}/${topicIdToUse}/${subtopicId}`
            : `/topics/${encodeURIComponent(topicLabel)}/${subtopicId}`;

        history.push({
            pathname,
            state: {
                selectedTopic: topicLabel,
                selectedSubtopic: subtopic,
                subtopicId: subtopicId
            }
        });
    };

    // Determine category tag color
    const getCategoryColor = () => {
        // Fallback
        if (!category_label && !topicName && !title) return 'blue';

        // Use a combined string so we match whether the text is coming
        // from category_label, topicName, or title
        const sourceText = `${category_label || ''} ${topicName || ''} ${title || ''}`.toLowerCase();

        if (sourceText.includes('newly wed') || sourceText.includes('newlywed')) {
            return 'blue';
        } else if (
            sourceText.includes('birth') ||
            sourceText.includes('upto') ||
            sourceText.includes('up to') ||
            (
                (sourceText.includes('8') || sourceText.includes('eight')) &&
                (sourceText.includes('14') || sourceText.includes('fourteen') || sourceText.includes('to 14') || sourceText.includes('child development'))
            )
        ) {
            // Birth up to 7 years and Child Development 8-14 years use pink
            return 'pink';
        } else if (
            // Life After Death → yellow
            (sourceText.includes('life') && sourceText.includes('after') && sourceText.includes('death')) ||
            // Stress Management → yellow
            (sourceText.includes('stress') && sourceText.includes('management')) ||
            // Meditation & Yoga → yellow
            (sourceText.includes('meditation') && sourceText.includes('yoga'))
        ) {
            return 'yellow';
        } else if (
            // Science of Spirituality → purple
            (sourceText.includes('science') && sourceText.includes('spirituality')) ||
            // Health Care → purple
            (sourceText.includes('health') && sourceText.includes('care'))
        ) {
            return 'purple';
        } else if (
            (sourceText.includes('15') || sourceText.includes('fifteen')) &&
            (sourceText.includes('28') || sourceText.includes('twenty-eight') || sourceText.includes('twenty eight'))
        ) {
            // 15 to 28 years → green
            return 'green';
        }

        return 'blue';
    };

    // Get background icon based on topic/category label
    const getBackgroundIcon = () => {
        // Use provided background_icon if available
        if (background_icon) {
            return background_icon;
        }
        
        if (!category_label) return null;
        
        const label = category_label.toLowerCase();
        
        // Map topic names to their corresponding icons
        // Check in order of specificity (more specific patterns first)
        
        // Birth up to 7 years
        if (label.includes('birth') && (label.includes('7') || label.includes('upto') || label.includes('up to') || label.includes('to 7'))) {
            return birthUpTo7Icon;
        }
        // 15 to 28 years (check before 8 to 14 to avoid conflicts)
        else if ((label.includes('15') || label.includes('fifteen')) && (label.includes('28') || label.includes('twenty-eight') || label.includes('twenty eight'))) {
            return fifteenToTwentyEightIcon;
        }
        // 8 to 14 years
        else if ((label.includes('8') || label.includes('eight')) && (label.includes('14') || label.includes('fourteen') || label.includes('to 14'))) {
            return eightToFourteenIcon;
        }
        // Newly Wed Couples
        else if (label.includes('newly wed') || label.includes('newlywed') || label.includes('suprajanan')) {
            return newlyWedIcon;
        }
        // Stress Management
        else if (label.includes('stress') && label.includes('management')) {
            return stressManagementIcon;
        }
        // Meditation & Yoga
        else if (label.includes('meditation') && label.includes('yoga')) {
            return meditationYogaIcon;
        }
        // Life After Death
        else if (label.includes('life') && label.includes('after') && label.includes('death')) {
            return lifeAfterDeathIcon;
        }
        // Health Care
        else if (label.includes('health') && label.includes('care')) {
            return healthCareIcon;
        }
        // Prenatal
        else if (label.includes('prenatal')) {
            return prenatalIcon;
        }
        // Science of Spirituality
        else if (label.includes('science') && label.includes('spirituality')) {
            return scienceOfSpiritualityIcon;
        }
        
        return null;
    };

    // Helper to get unified text for topic/category matching
    const getMatchText = () => {
        return `${category_label || ''} ${topicName || ''} ${title || ''}`.toLowerCase();
    };

    // Check if this is "Birth up to 7 years" topic for special styling
    const isBirthUpTo7Topic = () => {
        const text = getMatchText();
        return text.includes('birth') && (text.includes('7') || text.includes('upto') || text.includes('up to') || text.includes('to 7'));
    };

    // Check if this is Newly Wed topic for slight right shift
    const isNewlyWedTopic = () => {
        const text = getMatchText();
        return text.includes('newly wed') || text.includes('newlywed') || text.includes('suprajanan');
    };

    // Check if this is Meditation & Yoga topic for special positioning
    const isMeditationYogaTopic = () => {
        const text = getMatchText();
        return text.includes('meditation') && text.includes('yoga');
    };

    // Check if this is Prenatal topic for special positioning
    const isPrenatalTopic = () => {
        const text = getMatchText();
        return text.includes('prenatal') || text.includes('garbh') || text.includes('garbhsamarthya');
    };

    // Check if this is Stress Management topic (should also use yellow)
    const isStressManagementTopic = () => {
        const text = getMatchText();
        return text.includes('stress') && text.includes('management');
    };

    // Check if this is Life After Death topic for yellow filter
    const isLifeAfterDeathTopic = () => {
        const text = getMatchText();
        return text.includes('life') && text.includes('after') && text.includes('death');
    };

    // Check if this is Science of Spirituality topic for purple filter
    const isScienceOfSpiritualityTopic = () => {
        const text = getMatchText();
        return text.includes('science') && text.includes('spirituality');
    };

    // Check if this is Health Care topic (should share purple background with Science of Spirituality)
    const isHealthCareTopic = () => {
        const text = getMatchText();
        return text.includes('health') && text.includes('care');
    };

    // Check if this is 15 to 28 years topic for green filter
    const isFifteenToTwentyEightTopic = () => {
        const text = getMatchText();
        return (
            (text.includes('15') || text.includes('fifteen')) &&
            (text.includes('28') || text.includes('twenty-eight') || text.includes('twenty eight'))
        );
    };

    // Check if this is one of the topics that needs left-adjusted positioning
    // (8 to 14 years) - excluding Health Care, 15 to 28 years, Meditation & Yoga which have their own classes
    const needsLeftAdjustedPosition = () => {
        if (!category_label) return false;
        const label = category_label.toLowerCase();
        return (
            ((label.includes('8') || label.includes('eight')) && (label.includes('14') || label.includes('fourteen') || label.includes('to 14')))
        );
    };

    // Get the background icon to display
    const displayBackgroundIcon = getBackgroundIcon();
    
    // Lazy load background icon image for better performance
    useEffect(() => {
        if (displayBackgroundIcon) {
            const img = new Image();
            img.src = displayBackgroundIcon;
            img.onload = () => setImageLoaded(true);
        } else {
            setImageLoaded(true); // No image to load
        }
    }, [displayBackgroundIcon]);
    
    // Apply special styling if this is a topic icon (not a custom background_icon)
    const showTopicIcon = displayBackgroundIcon && !background_icon;
    // Special styling for Birth up to 7 years (left side, pink color)
    // Special styling for Birth up to 7 years and Child Development 8-14 years (left side, pink color)
    const isBirthUpTo7 = (
        (isBirthUpTo7Topic() && displayBackgroundIcon === birthUpTo7Icon && !background_icon) ||
        (needsLeftAdjustedPosition() && displayBackgroundIcon === eightToFourteenIcon && !background_icon)
    );
    // Special styling for Meditation & Yoga (positioned even more to the left)
    const isMeditationYoga = isMeditationYogaTopic() && displayBackgroundIcon === meditationYogaIcon && !background_icon;
    // Stress Management uses yellow background styling (same as Life After Death)
    const isStressManagement = isStressManagementTopic() && displayBackgroundIcon === stressManagementIcon && !background_icon;
    // Special styling for topics that need left-adjusted positioning
    const isLeftAdjusted = needsLeftAdjustedPosition() && displayBackgroundIcon && !background_icon && !isBirthUpTo7 && !isMeditationYoga;
    // Slight right shift for Newly Wed illustration
    const isNewlyWed = isNewlyWedTopic() && displayBackgroundIcon === newlyWedIcon && !background_icon;
    // Prenatal specific flag
    const isPrenatal = isPrenatalTopic() && displayBackgroundIcon === prenatalIcon && !background_icon;
    // Yellow filter for Life After Death
    const isLifeAfterDeath = isLifeAfterDeathTopic() && displayBackgroundIcon === lifeAfterDeathIcon && !background_icon;
    // Purple filter for Science of Spirituality
    const isScienceOfSpirituality = isScienceOfSpiritualityTopic() && displayBackgroundIcon === scienceOfSpiritualityIcon && !background_icon;
    // Health Care uses its own purple background styling
    const isHealthCare = isHealthCareTopic() && displayBackgroundIcon === healthCareIcon && !background_icon;
    // Green filter for 15 to 28 years
    const isFifteenToTwentyEight = isFifteenToTwentyEightTopic() && displayBackgroundIcon === fifteenToTwentyEightIcon && !background_icon;

    const categoryColor = getCategoryColor();

    return (
        <div className="event-card-new">
            <div ref={containerRef} className={`event-card-new__container event-card-new__container--${categoryColor} ${imageLoaded ? 'event-card-new__container--loaded' : ''}`}>
                {/* Share button (deep-link / copy) - top-right */}
                <button
                    type="button"
                    className="event-card-new__share-btn"
                    onClick={(e) => handleShare(e)}
                    aria-label="Share event"
                    title="Share"
                >
                    <img src={shareIcon} alt="Share" className="event-card-new__share-icon" />
                </button>
                {/* Background decorative illustration - only render when loaded */}
                {displayBackgroundIcon && imageLoaded && (
                    <div className={`event-card-new__background ${
                        isBirthUpTo7 ? 'event-card-new__background--birth-up-to-7' : 
                        isMeditationYoga ? 'event-card-new__background--meditation-yoga' :
                        isStressManagement ? 'event-card-new__background--life-after-death' :
                        isLeftAdjusted ? 'event-card-new__background--left-adjusted' : 
                        isNewlyWed ? 'event-card-new__background--newly-wed' :
                        isPrenatal ? 'event-card-new__background--prenatal' :
                        isLifeAfterDeath ? 'event-card-new__background--life-after-death' :
                        isScienceOfSpirituality ? 'event-card-new__background--science-of-spirituality' :
                        isHealthCare ? 'event-card-new__background--health-care' :
                        isFifteenToTwentyEight ? 'event-card-new__background--fifteen-to-twenty-eight' :
                        showTopicIcon ? 'event-card-new__background--topic-icon' : ''
                    }`}>
                        <img src={displayBackgroundIcon} alt="" aria-hidden="true" loading="lazy" />
                    </div>
                )}

                {/* Category label - Top left (clickable if topicId available) */}
                {category_label && (
                    topicId && topicName ? (
                        <Link 
                                to={getTopicUrl()} 
                                className={`event-card-new__category event-card-new__category--${getCategoryColor()} event-card-new__category--link`}
                                onClick={(e) => e.stopPropagation()} // Prevent event card click
                                ref={categoryRef}
                            >
                                {category_label}
                            </Link>
                    ) : (
                        <div ref={categoryRef} className={`event-card-new__category event-card-new__category--${getCategoryColor()}`}>
                            {category_label}
                        </div>
                    )
                )}

                {/* Active/Inactive Status Tag (preference: server hasActiveSchedule) */}
                {isActive !== undefined && (
                    <div className={`event-card-new__status-tag event-card-new__status-tag--${isActive ? 'active' : 'inactive'}`}>
                        {isActive ? 'Active' : 'Inactive'}
                    </div>
                )}

                {/* Next schedule date removed */}

                {/* Event Title */}
                <h3 className="event-card-new__title">
                    <Link to={getEventUrl()}>{title}</Link>
                </h3>

                {/* Description */}
                {description && (
                    <p className="event-card-new__description">
                        {description}
                    </p>
                )}

                {/* Subtopic line (shows first 1-2 subtopics) - moved below description */}
                {subtopics && subtopics.length > 0 && (
                    <div className="event-card-new__subtopics">
                        {subtopics.slice(0, 2).map((subtopic, index) => {
                            const subtopicId = subtopicIds && subtopicIds.length > index && subtopicIds[index] !== null && subtopicIds[index] !== undefined 
                                ? subtopicIds[index] 
                                : null;
                            
                            // console.log(`Subtopic ${index}: "${subtopic}", ID: ${subtopicId}, subtopicIds array:`, subtopicIds);
                            
                            return (
                                <React.Fragment key={index}>
                                    {index > 0 && <span className="event-card-new__subtopic-separator"> | </span>}
                                    {subtopicId ? (
                                        <span 
                                            className="event-card-new__subtopic event-card-new__subtopic--clickable"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                handleSubtopicClick(subtopic, subtopicId);
                                            }}
                                            role="button"
                                            tabIndex={0}
                                            onKeyPress={(e) => {
                                                if (e.key === 'Enter' || e.key === ' ') {
                                                    e.preventDefault();
                                                    handleSubtopicClick(subtopic, subtopicId);
                                                }
                                            }}
                                        >
                                            {subtopic}
                                        </span>
                                    ) : (
                                        <span className="event-card-new__subtopic">{subtopic}</span>
                                    )}
                                </React.Fragment>
                            );
                        })}
                    </div>
                )}

                {/* Keywords/Tags */}
                {keywords && keywords.length > 0 && (
                    <div className="event-card-new__keywords">
                        {keywords.map((keyword, index) => (
                            <React.Fragment key={index}>
                                {index > 0 && <span className="event-card-new__keyword-separator"> | </span>}
                                <span className="event-card-new__keyword">{keyword}</span>
                            </React.Fragment>
                        ))}
                    </div>
                )}

                {/* Language indicator */}
                {language && (
                    <div className="event-card-new__language">
                        <img 
                            src={languageIcon} 
                            alt="" 
                            className="event-card-new__language-icon"
                            aria-hidden="true"
                            loading="lazy"
                        />
                        <span className="event-card-new__language-text">Language : {language}</span>
                    </div>
                )}

                {/* Pricing and Know More button - Same line */}
                <div className="event-card-new__pricing-wrapper">
                    {/* Pricing */}
                    {pricing && pricing.length > 0 && (
                        <div className="event-card-new__pricing">
                            {pricing.map((price, index) => (
                                <div key={index} className="event-card-new__price-item">
                                    <span className="event-card-new__price-amount">INR {price.amount}/-</span>
                                    <span className="event-card-new__price-label"> per {price.label}</span>
                                </div>
                            ))}
                        </div>
                    )}
                    
                    {/* Know More button */}
                    <Link to={getEventUrl()} className="event-card-new__btn">
                        {t('home.Know More')}
                    </Link>
                </div>
            </div>
        </div>
    );
};

EventCardNew.propTypes = {
    event: PropTypes.shape({
        event_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        category_label: PropTypes.string,
        topicId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        topicName: PropTypes.string,
        subtopics: PropTypes.arrayOf(PropTypes.string),
        subtopicIds: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
        subtopicDisplay: PropTypes.string,
        title: PropTypes.string.isRequired,
        description: PropTypes.string,
        keywords: PropTypes.arrayOf(PropTypes.string),
        language: PropTypes.string,
        pricing: PropTypes.arrayOf(
            PropTypes.shape({
                amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                label: PropTypes.string
            })
        ),
        background_icon: PropTypes.string,
        title_url: PropTypes.string,
        eventType: PropTypes.string,
        eventTypeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        hasSchedule: PropTypes.bool
    }).isRequired,
    history: PropTypes.object,
    currentFilters: PropTypes.shape({
        events: PropTypes.arrayOf(PropTypes.string),
        topics: PropTypes.arrayOf(PropTypes.string),
        language: PropTypes.string,
        subTopics: PropTypes.arrayOf(PropTypes.string),
        subtopicIds: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number]))
    }),
    onShare: PropTypes.func,
    t: PropTypes.func
};

export default withRouter(translate(EventCardNew));

